import { Link, NavLink } from 'react-router-dom';
import { ThemeToggle } from '../layout/ThemeToggle';
import { useAuth } from '../../lib/auth';

const navItems = [
  { label: 'Features', to: '/features' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Security', to: '/security' }
];

export function PublicHeader(): JSX.Element {
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-40">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-4 sm:px-6">
        <Link
          to="/"
          className="glass inline-flex items-center gap-3 rounded-full border border-white/30 px-4 py-2 text-sm font-semibold text-foreground transition hover:shadow-lg dark:border-white/10"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-primary to-secondary text-sm font-bold text-white shadow-lg">
            IA
          </span>
          <span>InspectAI</span>
        </Link>

        <nav className="hidden items-center gap-6 text-sm font-medium text-muted-foreground md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                isActive
                  ? 'text-foreground underline underline-offset-[10px]'
                  : 'text-muted-foreground hover:text-foreground transition'
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          {user ? (
            <div className="flex items-center gap-2">
              <Link
                to="/app"
                className="btn-glass btn-secondary focus-ring border border-white/40 text-sm font-semibold text-foreground"
              >
                Open app
              </Link>
              <button
                type="button"
                onClick={logout}
                className="focus-ring rounded-full border border-border px-3 py-2 text-sm text-muted-foreground hover:text-destructive"
              >
                Sign out
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-2 text-sm font-medium">
              <Link to="/login" className="text-muted-foreground transition hover:text-foreground">
                Log in
              </Link>
              <Link
                to="/signup"
                className="btn-glass btn-primary focus-ring text-primary-foreground"
              >
                Start free trial
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
